import React from "react";
import AboutUs from "../components/Home/AboutUs/AboutUs";
import ContactUs from "../components/Home/ContactUs/ContactUs";
import Footer from "../components/Home/Footer/Footer";
import Header from "../components/Home/Header/Header";
import HowWeDid from "../components/Home/HowWeDid/HowWeDid";
import Services from "../components/Home/Services/Services";
// import Team from "../components/Home/Team/Team";
import Testimonials from "../components/Home/Testimonials/Testimonials";
import WhyUs from "../components/Home/WhyUS/WhyUs";
import Quote from "../components/Home/Quote/Quote";
import Nav from "../components/Nav/Nav";
import { Helmet } from "react-helmet";
import BlogsComponent from "../components/Home/Blogs";

const home = ({ data }) => {
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Enviary - eCommerce Email Marketing Automation Agency | Klaviyo
          Partner
        </title>
        <link rel="canonical" href="http://mysite.com/example" />
      </Helmet>
      <Nav home={true} />
      <div className="home__Content">
        <Header />
        <AboutUs />
        <WhyUs />
        <Services />
        <HowWeDid />
        {/* <Team /> */}
        {/* <Testimonials /> */}
        <Quote />
        {/* <BlogsComponent data={data} /> */}
        <ContactUs />
        <Footer home={true} />
      </div>
    </div>
  );
};

export const query = graphql`
  query MyQuery {
    allContentfulBlogPosts(sort: { order: ASC, fields: createdAt }, limit: 3) {
      nodes {
        title
        descriptionHighlight {
          descriptionHighlight
        }
        thumbnail {
          fluid {
            src
          }
          file {
            url
          }
        }
      }
    }
  }
`;

export default home;
